// client/src/pages/AuthorizeReturn.js
// Public DocuSign return landing (designed like Login)

import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import "./AuthorizeReturn.css";
import "./Dashboard.css";
import CphereHeaderLogo from "../components/CphereHeaderLogo";

const AuthorizeReturn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Ensure route-scoped CSS always applies (prevents mobile overflow + pill clipping)
  useEffect(() => {
    const prev = document.body.dataset.route;
    document.body.dataset.route = "/authorize/return";
    return () => {
      if (prev) document.body.dataset.route = prev;
      else delete document.body.dataset.route;
    };
  }, []);

  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  // DocuSign sometimes sends event/status query params
  const rawEvent = (params.get("event") || params.get("status") || "")
    .toLowerCase()
    .trim();

  // ✅ Updated to match SUPERADMIN messaging
  const message = useMemo(() => {
    if (rawEvent.includes("signing_complete") || rawEvent.includes("complete")) {
      return "Thank you. Your authorization has been received and is being finalized.";
    }
    if (rawEvent.includes("cancel")) {
      return "Signing was canceled. You can reopen the agreement from Authorizations at any time.";
    }
    if (rawEvent.includes("decline")) {
      return "The authorization was declined. If this was a mistake, please contact support.";
    }
    return "Signing session ended. If you completed signing, we’ve received it. Need assistance? Please contact your representative.";
  }, [rawEvent]);

  return (
    <div className="authreturn-page">
      <div className="authreturn-container">
        <CphereHeaderLogo
          alt="Cphere"
          className="authreturn-logo"
          draggable={false}
          onClick={() => navigate("/login")}
        />

        {/* ✅ MATCH LOGIN HERO DESIGN (same class stack as Login) */}
        <div className="campaignmanagement-hero-container authreturn-hero">
          <div className="campaignmanagement-hero-pill">
            <span className="campaignmanagement-hero-pill-label cphere-hero-pill-wordmark">Authorize</span>
            <span className="campaignmanagement-hero-pill-tag cphere-hero-pill-tag">Return</span>
          </div>
          <div className="campaignmanagement-hero-shimmer-bar" />
        </div>

        <div className="authreturn-message">{message}</div>

        <button
          type="button"
          className="authreturn-btn shimmer-button"
          onClick={() => navigate("/login")}
        >
          Login
        </button>

        <button
          type="button"
          className="authreturn-link"
          onClick={() => (window.location.href = "https://cphere.ai")}
        >
          Return Home
        </button>
      </div>
    </div>
  );
};

export default AuthorizeReturn;
